import { getWorkerUrl } from '@affine/env/worker';
import { OpClient, transfer } from '@toeverything/infra/op';

import type { ClientOps } from './ops';
import { type PdfRangeReader, servePdfSource } from './pdf-source';

export class PDFRenderer extends OpClient<ClientOps> {
  private readonly worker: Worker;
  private readonly sources: (() => void)[] = [];

  constructor() {
    const worker = new Worker(getWorkerUrl('pdf'));
    super(worker);

    this.worker = worker;
  }

  /**
   * Opens a PDF the worker reads range by range from `reader`; the file is
   * never handed over as a whole. Serving ends when the renderer is destroyed.
   */
  open(reader: PdfRangeReader) {
    return this.call('open', this.serve(reader));
  }

  /** Observable variant of `open` for entities that keep the subscription. */
  open$(reader: PdfRangeReader) {
    return this.ob$('open', this.serve(reader));
  }

  private serve(reader: PdfRangeReader) {
    const served = servePdfSource(reader);
    this.sources.push(served.close);
    return transfer(served.handle, [served.handle.port]);
  }

  override destroy() {
    super.destroy();
    for (const close of this.sources.splice(0)) close();
    this.worker.terminate();
  }

  [Symbol.dispose]() {
    this.destroy();
  }
}
